/**
 * created by lei lei on 2020/5/29
 * 活动排名组件
 */
import React, {Component} from 'react';
import ActivityRanking from './ActivityRanking'


export default class ActivityRankingComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className={'ActivityPendingComponents StaticMyDeskItemPaddingTop'} style={{width:'100%'}}>
                <div style={{background:'#FFFFFF',}}>
                    <div style={{height:56,lineHeight:'56px',background:'white',width: '100%',float:'left',borderBottom:'1px solid #ebebeb'}}>
                        <div style={{fontSize:14,paddingLeft:20,float:'left',color:'#333333'}}>
                            活动（选题）完成排名</div>
                        {/*  <div style={{fontSize:13,right:0,color:'#0050B3',float:'right',marginRight:20,cursor: 'pointer'}}>查看全部</div>*/}
                    </div>
                    <div style={{clear:'both'}}/>
                    <ActivityRanking
                        topBtnClick={(data)=>{
                            console.log('点击按钮',data)
                        }}
                        opetion={this.state.option}
                    />
                    {/*<ActivityCompletion
                        leftTitleList={this.state.leftTitleList}
                        leftNumKey={'num'}
                        opetion={this.state.option}

                        topBtnClick={(data)=>{
                            console.log(data)
                        }}
                    />*/}
                </div>
            </div>

        )
    }

}